import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Techdevelopment(props) {
    return (
        <div className="tekrevol_development p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="POS Services">
                            <h2>POS Development Services At TekRevol</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <h5 className="strong">TekRevol is a full-stack software development services provider covering
                            a wide range of all-things-tech and automation. Specific to our POS development, our main
                            offerings include:</h5>
                        <div className="bulet_points">
                            <ul>
                                <li>Omni-channel payment integration</li>
                                <li>Online payments API integrations</li>
                                <li>Custom POS development</li>
                                <li>POS integration</li>
                                <li>POS code review and audit</li>
                                <li>POS testing and automation</li>
                                <li>POS integration with on-table hardware</li>
                            </ul>
                        </div>
                        <p>Need more POS services for your business?</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Techdevelopment;